document.addEventListener('DOMContentLoaded', function () {
  var mySwiper = new Swiper('.formobile-product-slider .swiper-container', {
    zoom: {
      maxRatio: 3,
      minRatio: 1
    },
    scrollbar: {
      el: '.js-swiper-scrollbar',
      draggable: true,
      snapOnRelease: true
    }
  });

  // Zoom button toggle
  document.querySelectorAll('.zoom-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mySwiper.zoom.scale > 1) {
        mySwiper.zoom.out();
      } else {
        mySwiper.zoom.in();
      }
    });
  });
});
